import { Component, input, InputSignal } from '@angular/core';

export enum TooltipStyle {
  Default = 'default',
  Success = 'success'
}

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {
  style: InputSignal<TooltipStyle> = input<TooltipStyle>(TooltipStyle.Default);
  tooltip: InputSignal<string> = input('');
  left: InputSignal<number> = input(0);
  top: InputSignal<number> = input(0);
  visible: InputSignal<boolean> = input(false);
}
